import { AspectRatio } from "@ameelio/ui";
import { Box, Grid, Stack, useMediaQuery } from "@mui/material";
import {
  BaseSkeleton,
  ButtonSkeleton,
  ParagraphSkeleton,
  TitleSkeleton,
} from "../lib/closet";
import { belowLargeTablet } from "../lib/responsiveHelpers";

const VideoSkeleton = () => (
  <AspectRatio ratio={16 / 9}>
    <BaseSkeleton variant="rectangular" sx={{ width: 1, height: 1 }} />
  </AspectRatio>
);

export default function CallSkeleton() {
  const isMobileOrSmallTablet = belowLargeTablet(useMediaQuery);

  if (isMobileOrSmallTablet) {
    return (
      <Box
        sx={{
          p: 5,
          display: "flex",
          flexDirection: "column",
          height: 1,
          justifyContent: "flex-end",
        }}
      >
        <Stack spacing={4} sx={{ width: 1 }}>
          <TitleSkeleton />
          <ParagraphSkeleton />
          <ButtonSkeleton />
        </Stack>
      </Box>
    );
  }

  // split the screen in half. on the left side, center a large rectangle skeleton
  // where the self view will be. on the right side, show a title skeleton, a paragraph
  // skeleton, and a button skeleton below it.

  return (
    <Box
      sx={{
        display: "flex",
        height: 1,
        width: 1,
      }}
    >
      <Grid
        container
        sx={{
          p: 5,
          width: 1,
        }}
      >
        <Grid
          size={{ xs: 6 }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <VideoSkeleton />
        </Grid>
        <Grid
          size={{ xs: 6 }}
          sx={{
            pl: 5,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Stack spacing={4} sx={{ width: 1 }}>
            <TitleSkeleton />
            <ParagraphSkeleton />
            <ButtonSkeleton />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
